import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import { useDrodDetailModel } from "./drodDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Button, message, Modal, Radio } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IOfferExamine } from "@/views/inquires/offer/offerTypes";
import TextArea from "antd/lib/input/TextArea";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef, formRefSystem }) => {
    const { editFormVal, insertOrUpdateDrod, getDrodDetailOne, resetPageCache, submit, drawback } = useDrodDetailModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        if (!editFormVal.id && mode === "edit") {
            getDrodDetailOne(id)
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("9-3-1") && resetPageCache("add")
            !findNav("9-3-2") && resetPageCache("edit");
        }
    }, [selectedNavId])

    const orderStatu: IDescription[] = [
        {
            label: "退税单",
            value: editFormVal.code ?? "无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(editFormVal.status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
        // {
        //     label: "状态",
        //     value: getTreeNodeName(editFormVal.status ?? ""),
        //     color: DescriptionColorEnum.green,
        //     status: true
        // },
    ]


    //表单提交
    const onSubmit = async () => {
        let baseVal = await formRef.current?.validateFields()
        const systemVal = await formRefSystem.current?.validateFields()
        insertOrUpdateDrod(mode, {...baseVal, ...systemVal}).then(res => {
            if (mode === "add" && res) {
                resetPageCache("edit");
                replaceNav("9-3-1", "9-3-2", { id: res as string, mode: "edit" });
            }
        })
        // formRef.current?.validateFields().then((val: any) => {
        //     insertOrUpdateDrod(mode, val).then(res => {
        //         if (mode === "add" && res) {
        //             resetPageCache("edit");
        //             replaceNav("9-3-1", "9-3-2", { id: res as string, mode: "edit" });
        //         }
        //     })
        // }).catch((err: ValidateErrorEntity<any>) => {
        //     message.warning(getFormValidatorErrText(err));
        // })
    };

    //审批弹框
    const examineModal2 = (title: string) => {
        let obj: IOfferExamine = {
            status: "0",//默认是同意
        }
        Modal.confirm({
            title: title,
            content: <>
                <TextArea rows={4} placeholder="请输入审批意见" onChange={(e) => { obj.advise = e.target.value }} />
                <Radio.Group onChange={(e) => { obj.status = e.target.value }} defaultValue={obj.status}>
                    <Radio value={"0"}>同意</Radio>
                    <Radio value={"1"}>驳回</Radio>
                </Radio.Group>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    // if (obj.advise) {
                    resolve(obj);
                    // } else {
                    //     message.warning("请输入审批意见");
                    //     reject('请输入审批意见');
                    // }
                }).then((res: any) => {
                    // examineReckoner({
                    //     code: editFormVal.code,
                    //     status: res.status,
                    //     advise: res.advise,
                    // })
                });
            },
            onCancel: () => { }
        })
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.BACK_B_ED_SUBBACK}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={editFormVal.status !== "drawback-status.init"}
                onClick={() => {
                    formRef.current?.validateFields().then((val: any) => {
                        insertOrUpdateDrod("edit", val, false).then(res => {
                            res && submit()
                        })
                    }).catch((err: ValidateErrorEntity<any>) => {
                        message.warning(getFormValidatorErrText(err));
                    })
                }}
            >提交退税</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.BACK_B_ED_BACK}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={editFormVal.status !== "drawback-status.wait"}
                onClick={() => {
                    formRef.current?.validateFields().then((val: any) => {
                        insertOrUpdateDrod("edit", val, false).then(res => {
                            res && drawback()
                        })
                    }).catch((err: ValidateErrorEntity<any>) => {
                        message.warning(getFormValidatorErrText(err));
                    })
                }}
            >退税</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            // disabled={editFormVal.status === 'drawback-status.finish' ? true : false }
            onClick={() => { onSubmit() }}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "9-3")}
        >返回</Button>
    </>

    return (
        <YhBox
            title={orderStatu.map((item, index) => <Description key={index} {...item} />)}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}